import { observer } from 'mobx-react';
import { useCallback, useState } from 'react';
import Button from '../Controls/ButtonComponent/Button';
import Icon from '../Controls/Icon/Icon';
import Text, { TEXT } from '../Text/Text';
import AdvancedFilterStore from './advancedFilterStore';
import { AdvancedFilterContext } from './context';
import FilterModals from './FilterModals';
import './styles.scss';
import { AdvancedFilterProperties } from './types';
import { Icons } from 'src/assets/fonts/Icons/icons';

interface AdvancedFilterProps {
  store: AdvancedFilterStore;
}

const AdvancedFilter = ({ store }: AdvancedFilterProps) => {
  const [currentProperty, setCurrentProperty] = useState<AdvancedFilterProperties | null>(null);
  const [isFilterVisible, setIsFilterVisible] = useState(false);

  const handleOpenFilter = useCallback(() => {
    if (isFilterVisible) {
      return;
    }
    store.makeTempDataForUI();
    setCurrentProperty(null);
    setIsFilterVisible(true);
  }, [isFilterVisible, store]);

  const handleCloseFilter = useCallback(() => {
    setCurrentProperty(null);
    setIsFilterVisible(false);
  }, []);

  const handleChangeModalType = useCallback((modalType: AdvancedFilterProperties | null) => {
    setCurrentProperty(modalType);
  }, []);

  return (
    <Button
      onClick={handleOpenFilter}
      appearance="tertiary"
      className="advanced-filter-open-button ml-2"
      titleClassName="advanced-filter-open-button__title"
    >
      <Icon name={Icons.Filter} size={24} className="mr-2 color-mainblue" />
      <Text type={TEXT.CUSTOM} text="filters" />
      <AdvancedFilterContext.Provider value={{ store }}>
        <FilterModals
          visible={isFilterVisible}
          currentProperty={currentProperty}
          onCloseModal={handleCloseFilter}
          onChangeModal={handleChangeModalType}
        />
      </AdvancedFilterContext.Provider>
      {store.isChanged && <Icon name={Icons.Circle} size={24} className="filter-dot color-mainblue" />}
    </Button>
  );
};

export default observer(AdvancedFilter);
